import {Injectable} from '@angular/core';

import {environment} from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { shareReplay } from 'rxjs/operators';

const API_URL = environment.apiUrl;

@Injectable()
export class NavMenuService {

    items$ = this.http.get(`${API_URL}/api/apps/`).pipe(shareReplay(1));
    constructor(private http: HttpClient) {
    }

    getItems() {
        return this.items$.pipe(
          // map(data => {
          //   data[6]['isPrincipal'] = false;
          // })
        );
            // .toPromise()
            // .then(response => response)
            // .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

    public extractData(res: any) {
        const body = res.hasOwnProperty('items') ? res.items : res;
        return body || {};
    }

}
